// removed by extract-text-webpack-plugin
module.exports = {"Label":"_2v90aGlzGL-VYAR9xPwzrX"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Html/H3/style.css
// module id = 1544
// module chunks = 0